import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function FlashcardMathTopics() {
  return (
    <>

      <AllSubjectTopics subject="math" type="flashcard" />

    </>
  );
}

export default FlashcardMathTopics;